import { OLDialogProps } from './interfaces';

export const storeName = 'toast';

export const olDialogInitialState: OLDialogProps = {
  open: false,
  type: 'scorecard',
  params: {},
};
